<script setup lang="ts">
import { onMounted } from 'vue';
import { LoaderCircle } from 'lucide-vue-next';
import { toast, Toaster } from 'vue-sonner';
import useApp from '@/composables/useApp.ts';
import type { Flash, FlashType } from '@/types';

import 'vue-sonner/style.css';

import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils.ts';

const app = useApp();

onMounted(() => {
    if (app.flashes) {
        for (const [type, flash] of Object.entries(app.flashes) as [
            FlashType,
            Flash,
        ][]) {
            if (typeof flash === 'string') {
                toast?.[type]?.(flash);
            } else {
                toast?.[type]?.(flash.message, {
                    description: flash.description,
                });
            }
        }
    }
});
</script>

<template>
    <Toaster
        :toast-options="{
            unstyled: true,
            classes: {
                toast: 'font-sans bg-background text-foreground border rounded-md shadow-lg flex items-center gap-x-2 p-4 w-(--width)',
                title: 'p-small font-semibold',
                description: 'p-small text-muted-foreground',
                actionButton: cn(
                    buttonVariants({
                        variant: 'outline',
                        size: 'sm',
                    }),
                    'ml-auto'
                ),
            },
        }"
    >
        <template #loading-icon>
            <span>
                <LoaderCircle class="size-4 animate-spin" />
            </span>
        </template>
    </Toaster>
</template>
